<template>
  <div>
    <Datepicker v-model="date" placeholder="Select dates" @update:model-value="dateSelected" range auto-apply v-bind:partial-range="false" v-bind:enable-time-picker="false" v-bind:clearable="clearable" />

    <template v-if="hiddenFrom && hiddenTo">
      <input type="hidden" name="from" :value="hiddenFrom" />
      <input type="hidden" name="to" :value="hiddenTo" />
    </template>
  </div>
</template>

<script>
  import Datepicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';
  import { browserLocation } from '../../javascript/utils/browser-location.js';

  export default {
    components: { Datepicker },

    props: {
      submitOnChange: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        date: null,
        hiddenFrom: null,
        hiddenTo: null
      };
    },

    mounted() {
      const params = new URLSearchParams(browserLocation.getSearch());
      const from = params.get('from') ? new Date(params.get('from')) : null;
      const to = params.get('to') ? new Date(params.get('to')) : null;

      if (from === null && to === null) {
        this.date = null;
        return;
      }

      this.date = [from, to];
      this.hiddenFrom = from.toISOString().substring(0, 10);
      this.hiddenTo = to.toISOString().substring(0, 10);
    },

    methods: {
      dateSelected(modelData) {
        const from = modelData !== null ? modelData[0].toISOString().substring(0, 10) : "";
        const to = modelData !== null ? modelData[1].toISOString().substring(0, 10) : "";
        const params = new URLSearchParams(browserLocation.getSearch());
        params.set('from', from);
        params.set('to', to);
        const newUrl = `${window.location.pathname}?${params.toString()}`;

        history.pushState({}, null, newUrl);
        this.hiddenFrom = from;
        this.hiddenTo = to;

        if (this.submitOnChange) browserLocation.reload();
      }
    },
  };
</script>
